exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "html[dir] .bA6VMVlBESJO6HdvixVej{margin-top:10px}html[dir] .bA6VMVlBESJO6HdvixVej._2FkPsSh4Y0eE9jWNd6p5UV{margin-top:8px}html[dir] ._2uDB0Z5c1rxWY8VRiqJxWb{margin-bottom:10px;border-bottom:1px solid \"[theme:neutralLight, default:#edebe9]\"}._2OkgGgdIEzwQDiQglTUjwy{width:100%;overflow:hidden}._1XS3VVfwLJ8OaiPTMhyCLt{min-height:133px;max-height:133px}._2LcxnojN61-33eJMln7Igc{min-height:65px;max-height:65px}._3K0R6luHu6vP94NHx0eok3{height:auto}", ""]);
// Exports
exports.locals = {
	"attachmentWell": "bA6VMVlBESJO6HdvixVej",
	"unstackedReadingPane": "_2FkPsSh4Y0eE9jWNd6p5UV",
	"attachmentWellInCompose": "_2uDB0Z5c1rxWY8VRiqJxWb",
	"oneRowView": "_2OkgGgdIEzwQDiQglTUjwy",
	"oneRowViewImageHeight": "_1XS3VVfwLJ8OaiPTMhyCLt",
	"oneRowViewDocHeight": "_2LcxnojN61-33eJMln7Igc",
	"allowShowMultipleRows": "_3K0R6luHu6vP94NHx0eok3"
};